<template>
  <div class="unseiImg">
    <img v-if="this.unsei === 'daikichi'" src="@/assets/unsei-daikichi.png" alt="大吉">
    <img v-if="this.unsei === 'chukichi'" src="@/assets/unsei-chukichi.png" alt="中吉">
    <img v-if="this.unsei === 'kichi'" src="@/assets/unsei-kichi.png" alt="吉">
    <img v-if="this.unsei === 'kyou'" src="@/assets/unsei-kyou.png" alt="凶">
  </div>
</template>

<script>
export default {
  name: 'UnseiImages',
  props: {
    unsei: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
